module.exports = __webpack_public_path__ + "img/audience.5c6f96d3.svg";